<script>
  import Page from "../Components/common/Page.svelte";
  import Content from "../Components/test/Content.svelte";
  import Credentials from "../Components/test/Credentials.svelte";
  import Second from "../Components/test/Second.svelte";
  import Third from "../Components/test/Third.svelte";
  import Fourth from "../Components/test/Fourth.svelte";

  let components = [Fourth, Credentials, Second, Third];
  let added = [true];
  let removed = [false];
  let current = 0;

  // Initialise 'added' and 'removed' lists
  for (let i = 0; i < components.length - 1; i++) {
    added.push(false);
    removed.push(false);
  }

  // Display the next question/test item
  const next = () => {
    if (current + 1 == components.length) return;

    removed[current] = true;
    added[++current] = true;
  };
</script>

<style>
  button {
    position: absolute;
    bottom: 0;
  }

  section {
    position: relative;
    /* background: lightgrey; */
    height: 600px;
  }
</style>

<Page>
  <div class="full-page flex-col">
    <div class="top" />

    <!-- Start of content -->
    <section class="flex-row justify-center">
      <!-- Display questions -->
      {#each components as component, i}
        {#if added[i] === true}
          <Content removed={removed[i]} added={added[i]}>
            <svelte:component this={component} titleVisible={added[i]} />
          </Content>
        {/if}
      {/each}

      <button on:click={next}>Next</button>
    </section>
    <!-- End of content -->

    <div class="bottom" />
  </div>
</Page>
